import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import databaseService from '../services/databaseService';
import initService from '../services/initService';
import Footer from './Footer';

function Archives() {
  const [content, setContent] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadArchives = async () => {
      try {
        if (initService.isDatabaseAvailable()) {
          console.log('Loading archives from database...');
          try {
            const archives = await databaseService.getAllArchives();

            if (archives && archives.length > 0) {
              const organizedArchives = organizeArchivesByYear(archives);
              setContent(organizedArchives);
            } else {
              loadFallbackArchives();
            }
          } catch (error) {
            console.warn('Database query failed, using fallback:', error);
            loadFallbackArchives();
          }
        } else {
          console.log('Database not available, using fallback archives...');
          loadFallbackArchives();
        }
      } catch (error) {
        console.error("Failed to load archives:", error);
        loadFallbackArchives();
      } finally {
        setLoading(false);
      }
    };

    const loadFallbackArchives = async () => {
      try {
        const module = await import('../data/archives.json');
        setContent(module.default);
      } catch (error) {
        console.warn('Failed to load fallback archives:', error);
        setContent({
          name: 'Archives',
          description: 'Archives are temporarily unavailable',
          sections: []
        });
      }
    };

    loadArchives();
  }, []);

  const organizeArchivesByYear = (archives) => {
    // Group archives by year
    const grouped = {};

    archives.forEach(archive => {
      // Skip parenting category posts
      if (archive.category === 'parenting') return;

      const year = archive.year;

      if (!grouped[year]) {
        grouped[year] = [];
      }

      grouped[year].push(archive);
    });

    // Convert to simple sections format (like parenting.json)
    const sections = Object.keys(grouped)
      .sort((a, b) => b - a) // Sort years descending
      .map(year => {
        const posts = grouped[year]
          .sort((a, b) => new Date(b.date) - new Date(a.date)) // Sort by date descending
          .map(post => ({
            title: post.title,
            route: post.route,
            date: post.date
          }));

        return {
          title: year,
          posts: posts
        };
      });

    return {
      name: 'Archives',
      description: 'My thoughts and writings',
      sections: sections
    };
  };

  if (loading) return <div>Loading archives...</div>;
  if (content?.error) return <div>{content.error}</div>;
  if (!content) return <div>No archives found</div>;

  return (
    <div className="content-wrapper">
      <h1>{content.name}</h1>
      <p className="description">{content.description}</p>

      {content.sections && content.sections.map((section, sectionIndex) => (
        <div key={sectionIndex} className="section">
          <h2>{section.title}</h2>
          <ul>
            {section.posts && section.posts.map((post, postIndex) => (
              <li key={postIndex}>
                <Link to={post.route}>{post.title}</Link>
                {post.date && (
                  <span className="post-date-inline">
                    {' - '}
                    {new Date(post.date).toLocaleDateString('en-US', {
                      month: 'short',
                      day: 'numeric',
                      year: 'numeric'
                    })}
                  </span>
                )}
              </li>
            ))}
          </ul>
        </div>
      ))}

      <Footer />
    </div>
  );
}

export default Archives;
